<template>
  <figure class="relative w-full md:w-full mb-16 drop-shadow">
    <img
      class="logo-image"
      :src="`/uploads/keyvisual_logo_type_landscape_${$t('langShort')}.png`"
      alt="Moving World Logo"
      id="logo_image"
    />
  </figure>
</template>

<script>
import { mapGetters } from "vuex";
import { gsap } from "gsap";

export default {
  computed: {
    ...mapGetters({ isLoading: "loader/isLoading" }),
  },
  watch: {
    isLoading(newValue) {
      if (!newValue) {
        this.runLogoIntro();
      }
    },
  },
  methods: {
    runLogoIntro() {
      gsap.from("#logo_image", {
        scale: "1",
        y: "-1000",
        duration: "2",
        ease: "power3.inOut",
        delay: 2,
      });
    },
  },
};
</script>

<style lang="postcss" scoped>
@media screen and (max-height: 450px) {
  .logo-image {
    height: 80vh;
    margin: auto;
  }
}
.drop-shadow {
  -webkit-filter: drop-shadow(0 6px 18px rgba(0, 0, 0, 0.75));
  -moz-filter: drop-shadow(0 6px 18px rgba(0, 0, 0, 0.75));
  filter: drop-shadow(0 6px 18px rgba(0, 0, 0, 0.75));
}
</style>